/**
 * Auth Initializer Component
 *
 * Initializes authentication state on app load.
 * Delegates to useAuthInitializer (application layer); no direct infrastructure imports.
 */

import { useAuthInitializer } from '../../application/hooks';

import type { ReactNode } from 'react';

interface AuthInitializerProps {
  children: ReactNode;
}

/**
 * Wraps the app to initialize auth state on mount.
 * Checks for existing tokens and validates session via application hook.
 */
export function AuthInitializer({ children }: AuthInitializerProps) {
  useAuthInitializer();
  return <>{children}</>;
}
